/**
 * The network, said out loud (SPEC §8.3).
 *
 * A child must never believe an exercise is validated while it waits in a
 * queue. So the banner names two different things — being offline, and having
 * something not yet sent — and it never disappears silently between them.
 */

import { useEffect, useState } from "react";

import { list, subscribe, type OutboxItem } from "@/offline/outbox";
import { useOnline } from "@/offline/use-network";

export function NetworkBanner() {
  const online = useOnline();
  const [queued, setQueued] = useState<OutboxItem[]>([]);

  useEffect(() => {
    const refresh = () => void list().then(setQueued);
    refresh();
    return subscribe(refresh);
  }, []);

  if (online && queued.length === 0) return null;

  return (
    <p className="banner" role="status" data-tone={online ? "waiting" : "offline"}>
      {!online ? (
        <>Pas de réseau. Tu peux continuer : ce que tu écris part tout seul au retour.</>
      ) : (
        <>
          {queued.length === 1 ? "Une réponse attend d'être envoyée." : `${queued.length} réponses attendent d'être envoyées.`}{" "}
          Elles ne sont pas encore corrigées.
        </>
      )}
    </p>
  );
}
